import * as Sentry from '@sentry/react';
import { Severity } from '@sentry/react';

import { RootState } from '@app/index';

export const selectWithError =
  <T>(selector: (state: RootState) => T | undefined, selectorTarget: string) =>
  (state: RootState) => {
    const selectedState = selector(state);
    if (selectedState === undefined) {
      Sentry.withScope(scope => {
        scope.setTag('selectWithError.target', selectorTarget);
        scope.setLevel(Severity.Error);
        scope.setContext('selectWithError', {
          target: selectorTarget,
          url: typeof window !== 'undefined' ? window.location.href : null,
          hasUser: Boolean((state as { user?: { firebaseUser?: unknown } }).user?.firebaseUser),
          hasAppData: Boolean((state as { appData?: unknown }).appData),
        });
        Sentry.captureException(new Error(`${selectorTarget} is undefined`));
      });
      throw new Error(`${selectorTarget} is undefined`);
    }
    return selectedState;
  };
